<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Asignar clientes" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<div class="btn-group btn-group-sm rounded-pill flex-shrink-0">
						<button type="button" class="btn btn-dark rounded-start-pill" :disabled="selecteds.quantity == 0" @click="assign">{{ `Asignar${(selecteds.quantity > 0) ? ' (' + selecteds.quantity + ')' : ''}` }}</button>
						<div class="btn-group btn-group-sm" role="group">
							<button type="button" class="btn btn-secondary rounded-end-pill ps-2 pe-3" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-three-dots-vertical"></i></button>
							<ul class="dropdown-menu">
								<li>
									<a href="javascript:void(0);" class="dropdown-item vstack lh-xs" @click="selectScreen" v-if="(results?.data ?? []).length > 0">
										<div>Seleccionar todos</div>
										<small>Los clientes de la página</small>
									</a>
								</li>
								<li>
									<a href="javascript:void(0);" class="dropdown-item vstack lh-xs" @click="selectAll" v-if="(results?.data ?? []).length > 0">
										<div>Seleccionar todos</div>
										<small>Los clientes de la búsqueda</small>
									</a>
								</li>
								<li>
									<a href="javascript:void(0);" class="dropdown-item vstack lh-xs" @click="unselect" v-if="selecteds.quantity > 0">
										<div>Quitar selección</div>
										<small>De todos los clientes</small>
									</a>
								</li>
								<li class="text-muted text-xs px-1" v-if="(results?.data ?? []).length == 0 && selecteds.quantity == 0">No hay opciones</li>
							</ul>
						</div>
					</div>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-10">
			<LayoutTableMain :results="results" :loading="loading" @goPage="goPage">
				<template #filters>
					<div class="input-group input-group-sm rounded-pill">
						<span class="input-group-text bg-white rounded-start-pill pe-0" id="basic-addon1"><i class="bi bi-search"></i></span>
						<input type="text" v-model="filters.search" class="form-control border-start-0 rounded-end-pill" placeholder="Buscar..." />
					</div>
					<button type="button" class="btn btn-sm btn-neutral rounded-pill flex-shrink-0" @click="filter">+ Filtros</button>
				</template>
				<template #body>
					<CompanyLeaderCustomerTableRow v-for="data in results?.data" v-bind:key="data.id" :customer="data" :selecteds="selecteds" @select="select" />
				</template>
			</LayoutTableMain>
		</main>

		<CompanyLeaderCustomerAssign ref="modalAssign" :selecteds="selecteds" :filters="filters" @unselect="unselect" @reload="getResults" />
		<CommonModalFilter ref="modalFilter" @success="setFilters">
			<div class="row g-5">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.has_active_user" title="¿Tiene vendedor asignado?" placeholder="No filtrar" :options="{ 1: 'Con vendedor asignado', 0: 'Sin vededor asignado' }" />
				</div>
			</div>
			<div class="row g-5" v-if="extras.has_active_user == 1">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.user_id" title="Vendedor" placeholder="No filtrar" :options="usersOptions" />
				</div>
			</div>
			<div class="row g-5" v-if="extras.has_active_user == 1">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.status" title="Estado" placeholder="No filtrar" :options="statusesOptions" />
				</div>
			</div>
			<div class="row g-5">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.group_id" title="Grupo" placeholder="No filtrar" :options="groupsOptions" />
				</div>
			</div>
			<div class="row g-5">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.register_online" title="Tipo de registro" placeholder="No filtrar" :options="{ 1: 'En tienda online', 0: 'En tienda física' }" />
				</div>
			</div>
			<div class="row g-5">
				<div class="col-12">
					<CommonFormInputSelect v-model="extras.birthdate" title="Cumpleaños" placeholder="No filtrar" :options="{ 0: 'Hoy', 1: 'Entre hoy y mañana', 7: 'Hasta en 1 semana', 30: 'Hasta en 1 mes' }" />
				</div>
			</div>
			<div class="row g-5">
				<div class="col-6">
					<CommonFormInputNumber v-model="extras.total_buy.min" title="Compra total desde" placeholder="Ingrese el mínimo" />
				</div>
				<div class="col-6">
					<CommonFormInputNumber v-model="extras.total_buy.max" title="Hasta" subtitle="Opcional" placeholder="Ingrese el máximo" />
				</div>
			</div>
			<div class="row g-5">
				<div :class="{ 'col-6': !!extras.last_buy.type, 'col-12': !extras.last_buy.type }">
					<CommonFormInputSelect v-model="extras.last_buy.type" title="Última compra" placeholder="No filtrar" :options="{ less: 'Hace menos de', more: 'Hace más de' }" />
				</div>
				<div class="col-6" v-if="extras.last_buy.type">
					<CommonFormInputSelect v-model="extras.last_buy.months" title="Tiempo" :options="months" />
				</div>
			</div>
		</CommonModalFilter>
	</div>
</template>

<script>
	import { ref, reactive, computed, watch, onMounted, inject } from 'vue';
	import { useRoute } from 'vue-router';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';
	import CompanyLeaderGroupRepository from '@/repositories/modules/Company/Leader/Group';
	import CompanyLeaderCustomerRepository from '@/repositories/modules/Company/Leader/Customer';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const $env = inject('$env');
			const route = useRoute();
			const users = ref([]);
			const usersOptions = computed(() => _.mapValues(_.keyBy(users.value, 'id'), 'name'));
			const statusesOptions = computed(() => _.mapValues($env.MODEL.CustomerUser.statuses, (role) => role.title));
			const groups = ref([]);
			const groupsOptions = computed(() => _.mapValues(_.keyBy(groups.value, 'id'), 'name'));
			const results = ref({});

			const selecteds = ref({
				type: null,
				ids: [],
				quantity: 0
			});

			const extras = reactive({
				has_active_user: null,
				user_id: null,
				status: null,
				group_id: null,
				register_online: null,
				birthdate: route.query.birthdate ?? null,
				last_buy: {
					type: null,
					months: '1'
				},
				total_buy: {
					min: null,
					max: null
				}
			});

			const filters = reactive({
				search: null,
				extras: _.cloneDeep(extras),
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const months = {};
			for(var i = 1; i <= 12; i++) months[i] = (i == 1) ? '1 Mes' : `${i} Meses`;

			const select = (data) => {
				selecteds.value.type = 'custom';

				const index = _.indexOf(selecteds.value.ids, data.id);
				if(index !== -1) selecteds.value.ids.splice(index, 1);
				else selecteds.value.ids.push(data.id);
			}

			const selectScreen = () => {
				selecteds.value.type = 'custom';

				_.forEach(results.value.data, (customer) => {
					if(_.indexOf(selecteds.value.ids, customer.id) == -1) select(customer);
				});
			}

			const selectAll = () => {
				selecteds.value.type = 'all';
				selecteds.value.ids = [];
			}

			const unselect = () => {
				selecteds.value.type = null;
				selecteds.value.ids = [];
			}

			watch(() => [selecteds.value.type, selecteds.value.ids, results.value], () => {
				selecteds.value.quantity = (selecteds.value.type == 'all') ? results.value.total : selecteds.value.ids.length;
			}, { deep: true });

			const getResults = async () => {
				loading.value = true;

				await CompanyLeaderCustomerRepository.index(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const modalFilter = ref(null);
			const filter = () => modalFilter.value.show();
			const setFilters = () => {
				filters.extras = extras;
				goPage(1);
			}

			const modalAssign = ref(null);
			const assign = () => modalAssign.value.show();

			const timeout = ref(null);
			watch(() => filters.search, () => {
				if(timeout.value) clearTimeout(timeout.value);
				timeout.value = setTimeout(() => goPage(1), 1000);
			});

			onMounted(async () => {
				filters.extras = extras;
				getResults();

				try {
					const [ userResponse, groupResponse ] = await Promise.all([
						CompanyAdminUserRepository.list({ role: 'seller' }),
						CompanyLeaderGroupRepository.list()
					]);

					if(userResponse?.data !== undefined) {
						users.value = userResponse.data;
					}

					if(groupResponse?.data !== undefined) {
						groups.value = groupResponse.data;
					}
				}catch(e) {
					catchError(e, true);
				}
			});

			return { loading, selecteds, filters, extras, months, usersOptions, statusesOptions, groups, groupsOptions, results, getResults, goPage, select, selectScreen, selectAll, unselect, modalFilter, filter, setFilters, modalAssign, assign };
		}
	}
</script>